<template>
  <div class="asWarning" data-cy="warning">
    <span class="asWarning_title">{{$t('attention')}}!</span>
    <span class="asWarning_text">
      <slot>{{$t('warningStep')}}</slot>

      <img src="../assets/images/icon-button-arrow-down.svg" alt="" class="asWarning_icon">
    </span>
  </div>
</template>

<style lang="scss">
  .asWarning {
    padding: 17px 13px 14px 34px;
    box-shadow: 0 0 12px rgba(5, 17, 35, 0.21);
    background-image: linear-gradient(77deg, rgb(62, 98, 249) 0%, rgb(176, 63, 251) 100%);

    &.-big {
      padding: 36px 40px 44px;
    }

    &_title {
      display: flex;
      align-items: center;
      padding-bottom: 4px;

      color: rgb(255, 255, 255);
      font-size: 16px;
      line-height: 20px;

      &::after {
        content: '';

        display: block;
        width: 14px;
        height: 17px;
        margin-left: 9px;

        background-image: url(../assets/images/icon-lock.svg);
      }
    }

    &.-big &_title {
      font-size: 20px;
      padding-bottom: 10px;

      &::after {
        width: 18px;
        height: 21px;
        background-size: cover;
      }
    }

    &_text {
      color: rgba(255, 255, 255, .7);
      font-size: 14px;
      line-height: 20px;
    }

    &.-big &_text {
      display: flex;
    }

    &_icon {
      display: none;
      width: 57px;
      height: 57px;
      margin-top: -20px;
      margin-left: auto;
    }

    &.-big &_icon {
      display: block;
    }

    a {
      color: white;
    }
  }
</style>
